import { IBaseFloatingSuggestionsProps } from '../FloatingSuggestions.types';
import { IPersonaProps } from 'office-ui-fabric-react/lib/Persona';

export type IFloatingPeopleSuggestionsProps = IBaseFloatingSuggestionsProps<IPersonaProps>;
